import { SagaIterator } from "@redux-saga/core";
import { call, put, takeLatest } from "redux-saga/effects";

import apiService from "@/App/service";
import { ActionTypes } from "@/App/constants/actionTypes";
import { getPricingLevelActions } from "@/App/actions";

const showPageAlert = (payload: Record<string, unknown>) => ({
  type: "SHOW_PAGE_ALERT" as const,
  payload,
});

export function* getPricingLevel(payload: {}): Generator {
  return yield apiService({
    url: "/pricing_level/get",
    method: "POST",
    data: { id: payload },
  });
}

export function* getPricingLevelWorker(
  action: ReturnType<typeof getPricingLevelActions.getPricingLevel>,
): SagaIterator {
  const { payload } = action;
  const { getPricingLevelResults } = getPricingLevelActions;

  try {
    const pricingLevel = yield call(getPricingLevel, payload);

    yield put(getPricingLevelResults(pricingLevel));
  } catch (error) {
    const { data: { message = "" } = {} } = error;
    yield put(showPageAlert({ show: true, type: "error", message: message }));
  }
}

export default function* getPricingLevelWatcher(): SagaIterator {
  yield takeLatest(ActionTypes.GET_PRICING_LEVEL, getPricingLevelWorker);
}
